import { render, staticRenderFns } from "./ListaCamposCabecalho.vue?vue&type=template&id=181ec37b&"
import script from "./ListaCamposCabecalho.vue?vue&type=script&lang=js&"
export * from "./ListaCamposCabecalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports